import style from "./Footer.module.scss";

export function Footer() {
  return (
    <footer id="zoom">
      <div className={style.limit}>
        <div className={style.copyright}>
          2024 - 2025 © Rocket-Proxy. All rights reserved
        </div>
        <div className={style.links}>
          <a href="https://api.rocket-proxy.io/redoc" target="_blank" rel="noopener noreferrer">API</a>
        </div>
      </div>
    </footer>
  );
}
